// extracted by mini-css-extract-plugin
export var cardLayout = "_86-1";
export var paginationContainer = "_86-0";